/**
 * Created by Schon on 2018/9/13 0013.
 */
//设置cookie
export function setCookie(key, value) {
    var exdate = new Date(); //获取时间
    exdate.setTime(exdate.getTime() + 24 * 60 * 60 * 1000 * 15); //保存的天数，我这里写的是100年
    //字符串拼接cookie
    window.document.cookie = key + "=" + value + ";path=/;expires=" + exdate.toGMTString();
};
//读取cookie
export function getCookie(param) {
    var c_param = '';
    if (document.cookie.length > 0) {
        var arr = document.cookie.split('; '); //这里显示的格式需要切割一下自己可输出看下
        for (var i = 0; i < arr.length; i++) {
            var arr2 = arr[i].split('='); //再次切割
            //判断查找相对应的值
            if (arr2[0] == param) {
                c_param = arr2[1];
                //保存到保存数据的地方
            }
        }
        return c_param;
    }
};
function padLeftZero(str) {
    return ('00' + str).substr(str.length);
};

// 移除cookie
export function removeCookie(param) {
    setCookie(param, '', -1)
};

const sessionStorage = window.sessionStorage;
const localStorage = window.localStorage;

/*
*  sessionStorage本地缓存 当前浏览器窗口关闭数据就会消失
* */
export function setSessionStorage(key, value) {
    sessionStorage.setItem(key, value)
}

export function getSessionStorage(key) {
    return sessionStorage.getItem(key)
}

export function removeSessionStorage(key) {
    sessionStorage.removeItem(key)
}

/*
*  localStorage本地缓存 只有在有效时间内存在，否则一直存在，除非时间到期或者认为清除缓存数据
* */
export function setLocalStorage(key, value) {
    localStorage.setItem(key, value)
}

export function getLocalStorage(key) {
    return localStorage.getItem(key)
}

export function removeLocalStorage(key) {
    localStorage.removeItem(key)
}



// WEBPACK FOOTER //
// ./src/utils/cookieUtil.js